import React, { useEffect, useState } from "react"
import styled, { keyframes } from "styled-components"
import fonts from "../../../styles/fonts"
import colors from "../../../styles/colors"
import PropTypes from "prop-types"
import Eye from "../../../resources/img/ui/form/eye.svg"
import CrossedEye from "../../../resources/img/ui/form/crossed-eye.svg"

const liftUp = () => keyframes`
  0%{
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    transform: translateY(18px);
  }
  100% {
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 0.21px;
    transform: translateY(0);
  }
`;

const FieldContainer = styled.div`
  display: flex;
  width: 100%;
  position: relative;
`
const StyledInput = styled.input`
  ${fonts.helveticaNeueCondensedMedium};
  color: ${props => props.faded ? "#979797" : "#5F5E5C"};
  /* text-transform: ${props => props.isPassword ? "none" : "uppercase"}; */
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.3px;
  background: transparent;
  outline: none;
  border: none;
  border-bottom: 1px solid ${colors.black};
  border-color: ${(props) => props.error && colors.errorRed};
  border-color: ${(props) => props.faded && "#979797"};
  width: 100%;
  padding: 0 0 9px;

  ::-webkit-input-placeholder {
    ${fonts.helveticaNeueCondensedMedium};
    text-transform: uppercase;
    color: #979797;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    opacity: 0.7;
  }
  ::-moz-placeholder {
    ${fonts.helveticaNeueCondensedMedium};
    text-transform: uppercase;
    color: #979797;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    opacity: 0.7;
  }
  :-ms-input-placeholder {
    ${fonts.helveticaNeueCondensedMedium};
    text-transform: uppercase;
    color: #979797;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    opacity: 0.7;
  }
  :-moz-placeholder {
    ${fonts.helveticaNeueCondensedMedium};
    text-transform: uppercase;
    color: #979797;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    opacity: 0.7;
  }

  :-webkit-autofill,
  :-webkit-autofill:hover,
  :-webkit-autofill:focus,
  :-webkit-autofill:active {
    box-shadow: ${props => (props.isPopup || props.autofillWhite) ? `0 0 0 28px ${colors.white} inset !important` : `0 0 0 28px ${colors.beige} inset !important`};
    -webkit-box-shadow: ${props => (props.isPopup || props.autofillWhite) ? `0 0 0 28px ${colors.white} inset !important` : `0 0 0 28px ${colors.beige} inset !important`};
    font-family: 'Helvetica Neue Condensed Medium', Arial, sans-serif !important;
    font-size: 14px !important;
    line-height: 18px !important;
    letter-spacing: 0.3px !important;
    background: transparent !important;
    color: #5F5E5C !important;
    
  }

  @media (min-width: 720px) {
    :-webkit-autofill,
    :-webkit-autofill:hover,
    :-webkit-autofill:focus,
    :-webkit-autofill:active {
      box-shadow: ${props => props.autofillWhite ? `0 0 0 28px ${colors.white} inset !important` : `0 0 0 28px ${colors.beige} inset !important`};
      -webkit-box-shadow: ${props => props.autofillWhite ? `0 0 0 28px ${colors.white} inset !important` : `0 0 0 28px ${colors.beige} inset !important`};
    }
  }

  :-webkit-autofill {
    -webkit-text-fill-color: #5F5E5C !important;
    ${fonts.helveticaNeueLight};
    color: ${colors.greyDark};
    font-size: 14px !important;
    line-height: 18px !important;
    letter-spacing: 0.3px !important;
  }
`

const FieldError = styled.p`
  position: absolute;
  bottom: -2px;
  left: 0;
  color: ${colors.errorRed};
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.26px;
  opacity: 0.7;
  ${fonts.helveticaNeueCondensedMedium};
  transform: translateY(100%);
`

const Placeholder = styled.p`
  position: absolute;
  top: -16px;
  left: 0;
  ${fonts.helveticaNeueCondensedMedium};
  text-transform: uppercase;
  color: #979797;
  font-size: 10px;
  line-height: 18px;
  letter-spacing: 0.21px;
  opacity: 0.7;
  -webkit-animation: ${liftUp} 0.15s ease;
  animation: ${liftUp} 0.15s ease;
`

const PasswordButton = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  bottom: 12px;
  width: 16px;
  height: 12px;

  img {
    width: 100%;
    height: auto;
  }
`

const Field = ({
  data,
  name,
  placeholder,
  handleChange,
  label,
  type = "text",
  date,
  error,
  disabled,
  reset,
  setReset,
  faded,
  isPopup,
  autofillWhite
}) => {
  const [value, setValue] = useState(data[name])
  const [showPassword, setShowPassword] = useState(false)
  const isPassword = type === "password"

  useEffect(() => {
    handleChange(name, value)
  }, [value])

  useEffect(() => {
    if(reset === true) {
      setValue(data[name])
      setReset(false)
    }
  },[reset])

  const changeValue = (e) => {
    if (!date) {
      setValue(e.target.value)
      return
    }

    const valueLength = value.length
    const targetLength = e.target.value.length
    const backspacePress = valueLength === targetLength + 1
    if (backspacePress) {
      setValue(e.target.value)
      return
    }

    if (targetLength === 2 || targetLength === 5) {
      let currentValue = e.target.value
      currentValue += "/"
      setValue(currentValue)
      return
    }
    setValue(e.target.value)
  }

  const toggleShowPassword = (e) => {
    e.preventDefault()
    setShowPassword(!showPassword)
  }

  return (
    <FieldContainer>
      {value.length > 0 && <Placeholder>{placeholder}</Placeholder>}
      <StyledInput
        type={!isPassword ? type : showPassword ? "text" : "password"}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={changeValue}
        area-label={label}
        maxLength={date && 10}
        error={error}
        disabled={disabled}
        isPassword={isPassword}
        faded={faded}
        isPopup={isPopup}
        autofillWhite={autofillWhite}
      />
      {isPassword && <PasswordButton type="button" aria-label={showPassword ? "Hide password" : "Show password"} onClick={toggleShowPassword} >
        <img src={showPassword ? CrossedEye : Eye} alt={showPassword ? "Hide password" : "Show password"} />
      </PasswordButton>}
      {error && <FieldError>*{error}</FieldError>}
    </FieldContainer>
  )
}

Field.propTypes = {
  data: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string,
  date: PropTypes.bool,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  reset: PropTypes.bool,
  setReset:PropTypes.func,
  faded: PropTypes.bool,
  isPopup: PropTypes.bool,
  autofillWhite: PropTypes.bool
}

export default Field
